/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { WebAppTemplate } from "../../components/templates/WebAppTemplate";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_DOSAGE_CALCULATORS } from "../../services/clients/bffConfig/querys/DosageCalculatorQuery";
import { BBLoadingGif } from "../../blackbook-components/quarks/blackbook-loading";
import { useTrack } from "../../services/hooks/useTrack";
const Container = styled.div`
  padding: 20px;
  background-color: #121212;
  min-height: 100vh;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ButtonContainer = styled.button`
  width: 100%;
  border: none;
  border-top: 1px solid white;
  :last-child {
    border-bottom: 1px solid white;
  }
  padding: 15px 20px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
`;

const ButtonText = styled.p`
  color: white;
  text-align: left;
  font-size: 14px;
  margin: 0;
`;

export function WebAppDosageCalculators() {
  const history = useHistory();
  const { trackEvent } = useTrack();
  const [dosageCalculators, setDosageCalculators] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const [fetchCalculators] = useLazyQuery(GET_ALL_DOSAGE_CALCULATORS, {
    fetchPolicy: "cache-first",
    onCompleted: (data) => {
      if (data?.getAllDosageCalculators) {
        const calculators = data.getAllDosageCalculators
          .filter((calc: any) => calc.isReviewed === true)
          .map((calc: any) => ({
            ref: calc.ref,
            title: calc.title,
          }));

        setDosageCalculators(calculators);
      }
      setLoading(false);
    },
    onError: (error) => {
      console.error("[WebAppDosageCalculators] Error fetching dosage calculators:", error);
      setDosageCalculators([]);
      setLoading(false);
    },
  });

  useEffect(() => {
    fetchCalculators();
  }, []);

  if (loading) {
    return (
      <WebAppTemplate>
        <Container>
          <LoadingContainer>
            <BBLoadingGif />
          </LoadingContainer>
        </Container>
      </WebAppTemplate>
    );
  }

  return (
    <WebAppTemplate>
      <Container>
        <Content>
          {dosageCalculators.map((calc: any) => (
            <ButtonContainer
              key={calc.ref}
              onClick={() => {
                history.push(`/app/calculators/${calc.ref}`);
                trackEvent("Abriu calculadora de doses pediátrica", {
                  calculadora: calc.title,
                });
              }}
            >
              <ButtonText>{calc.title}</ButtonText>
            </ButtonContainer>
          ))}
        </Content>
      </Container>
    </WebAppTemplate>
  );
}
